export default "__VITE_ASSET__DeuhX9U2__"